/* eslint-disable  */
import React, { useEffect, useState } from "react";
import RenderAdminPage from "../RenderAdminPage";
import { useDispatch, useSelector } from "react-redux";
import {
  GetLoanAllReport,
  GetLoanReport,
  GetMartReport,
} from "../../services/Actions/dataAction";
import { RolesContants } from "../../contants";
import { GetUserProfile } from "../../services/Actions/authActions";
import { ToastContainer, toast } from "react-toastify";
import { bindActionCreators } from "redux";
import { dataActionCreators } from "../../services/Actions";
import { FaDownload, FaRegFilePdf } from "react-icons/fa";
import "./AdminReport.css";

// Inline button spinner
function Spinner() {
  return (
    <svg
      className="animate-spin h-4 w-4 text-white"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
      />
    </svg>
  );
}

// Status options per report type
const STATUS_OPTIONS = {
  loans: [
    { value: "submitted", label: "Submitted Report" },
    { value: "booked", label: "Booked Report" },
    { value: "initiated", label: "Initiated Report" },
    { value: "paid", label: "Paid Report" },
    { value: "authorized", label: "Authorized Report" },
    { value: "rejected", label: "Rejected Report" },
  ],
  mart: [
    { value: "initiated", label: "Initiated Orders" },
    { value: "approved", label: "Approved Orders" },
    { value: "shipped", label: "Shipped Orders" },
    { value: "rejected", label: "Rejected Orders" },
  ],
};

function AdminReport() {
  const dispatch = useDispatch();
  const { ResetDataResponse } = bindActionCreators(
    dataActionCreators,
    dispatch
  );

  // "loans" | "mart"
  const [reportType, setReportType] = useState("loans");
  const [formData, setFormData] = useState({
    category: "",
    fromDate: "",
    toDate: "",
  });
  // Which button triggered the current download: "range" | "all" | null
  const [activeAction, setActiveAction] = useState(null);

  const data = useSelector((state) => state?.data);
  const user = useSelector((state) => state?.auth);
  const { isLoading, response } = data;

  const isMart = reportType === "mart";
  const entity = isMart ? "order" : "loan";

  useEffect(() => {
    dispatch(GetUserProfile());
  }, [dispatch]);

  // Clear the active button once the download finishes
  useEffect(() => {
    if (!isLoading) setActiveAction(null);
  }, [isLoading]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSwitchType = (type) => {
    if (type === reportType) return;
    setReportType(type);
    // Status options differ between loans and mart, so reset the selection.
    setFormData((prev) => ({ ...prev, category: "" }));
  };

  const isAuthorized = () => user?.role?.includes(RolesContants.ADMIN);

  const handleGenerate = () => {
    if (!isAuthorized()) {
      toast.error(`You are not authorized to generate ${entity} reports`);
      return;
    }
    if (!formData.category) {
      toast.error("Select a status to generate the report");
      return;
    }
    if (!formData.fromDate || !formData.toDate) {
      toast.error("Choose the date range. This is required");
      return;
    }
    setActiveAction("range");
    if (isMart) {
      dispatch(
        GetMartReport(formData.category, formData.fromDate, formData.toDate)
      );
    } else {
      dispatch(
        GetLoanReport({
          ...formData,
          is_all: false,
          isOneDomain: false,
        })
      );
    }
  };

  const handleGenerateAll = () => {
    if (!isAuthorized()) {
      toast.error(`You are not authorized to generate ${entity} reports`);
      return;
    }
    // Mart "all" is still scoped to a date range; loans "all" exports everything.
    if (isMart && (!formData.fromDate || !formData.toDate)) {
      toast.error("Choose the date range. This is required");
      return;
    }
    setActiveAction("all");
    if (isMart) {
      dispatch(GetMartReport("all", formData.fromDate, formData.toDate));
    } else {
      dispatch(GetLoanAllReport());
    }
  };

  useEffect(() => {
    if (response?.state === "SUCCESS") {
      toast.success(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    } else if (response?.state === "ERROR") {
      toast.error(response?.message);
      setTimeout(() => {
        ResetDataResponse();
      }, 1500);
    }
  }, [response?.state, ResetDataResponse]);

  return (
    <div>
      <RenderAdminPage title="Report">
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 sm:p-8 mt-2">
          <div className="text-center mb-6">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-indigo-100 dark:bg-indigo-900/30 mb-3">
              <FaRegFilePdf className="text-indigo-600 dark:text-indigo-400 text-xl" />
            </div>
            <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Generate Report</h2>
          </div>

          {/* Report type selector */}
          <div className="flex justify-center mb-6">
            <div className="inline-flex p-1 rounded-xl bg-slate-100 dark:bg-gray-700/50 border border-slate-200 dark:border-gray-600">
              {[
                { key: "loans", label: "Loans Report" },
                { key: "mart", label: "Mart Report" },
              ].map((t) => (
                <button
                  key={t.key}
                  type="button"
                  onClick={() => handleSwitchType(t.key)}
                  className={`px-5 py-2 rounded-lg text-sm font-semibold transition-all ${
                    reportType === t.key
                      ? "bg-indigo-600 text-white shadow-sm"
                      : "text-slate-600 dark:text-slate-300 hover:text-indigo-600 dark:hover:text-indigo-400"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-2">
            <div>
              <label htmlFor="category" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Status</label>
              <select
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="category"
                name="category"
                value={formData.category}
                onChange={handleChange}
              >
                <option value="" disabled>Select Status</option>
                {STATUS_OPTIONS[reportType].map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label htmlFor="fromDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">From</label>
              <input
                type="date"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="fromDate"
                name="fromDate"
                value={formData.fromDate}
                onChange={handleChange}
              />
            </div>

            <div>
              <label htmlFor="toDate" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">To</label>
              <input
                type="date"
                className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all"
                id="toDate"
                name="toDate"
                value={formData.toDate}
                onChange={handleChange}
              />
            </div>
          </div>

          <p className="text-xs text-slate-500 dark:text-slate-400 text-center mb-6">
            Pick a status and date range to generate, or use{" "}
            <span className="font-medium">Generate All</span>{" "}
            {isMart
              ? "to export every order within the date range."
              : "to export every loan record."}
          </p>

          <div className="flex items-center justify-center gap-3 pt-4 border-t border-slate-100 dark:border-gray-700">
            <button
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-green-600 hover:bg-green-700 text-white text-sm font-semibold transition-colors shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
              onClick={handleGenerate}
              disabled={isLoading}
            >
              {isLoading && activeAction === "range" ? (
                <>
                  <Spinner /> Generating...
                </>
              ) : (
                <>
                  <FaDownload /> Generate
                </>
              )}
            </button>
            <button
              onClick={handleGenerateAll}
              disabled={isLoading}
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {isLoading && activeAction === "all" ? (
                <>
                  <Spinner /> Generating...
                </>
              ) : (
                <>
                  <FaDownload /> Generate All
                </>
              )}
            </button>
          </div>
        </div>

        <ToastContainer autoClose={3000} />
      </RenderAdminPage>
    </div>
  );
}

export default AdminReport;
